import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { debug } from 'util';
import { ControDeAcesso } from '../../../models/controle-acesso/ControleDeAcesso';
import { ApiIntegracao } from '../../../models/acesso-api/AcessoApi.model';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AcessoApiService {
  private handleError: HandleError;


  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {

    this.handleError = httpErrorHandler.createHandleError('AcessoApiService');
  }

  obter(): Observable<any> {
    return this.http.get<ApiIntegracao>(`${API_URL}/v1/integration`)
      .pipe(
        catchError(this.handleError('obter', []))
      );
  }

  create(): Observable<any> {

    return this.http.post<ApiIntegracao>(`${API_URL}/v1/integration`, null)
      .pipe(
        catchError(this.handleError('create', null))
      );
  }
}
